<template>
  <v-container grid-list-md>
     <v-overlay
        absolute
        class="d-flex flex-column text-center"
        opacity="0.35"
        z-index="1"
        :value="peticionDocCliente"
      >
        <div>
          <v-progress-circular width="2" size="50" color="white" indeterminate>
            <v-icon size="30">mdi-timer-sand</v-icon>
          </v-progress-circular>
        </div>
        Cargando Datos...
      </v-overlay>
    <v-card class="mx-auto" width="500" v-if="!peticionDocCliente">
     
      <v-alert
        v-if="!peticionDocCliente && itemsCliente.length === 0"
        icon="mdi-minus-circle"
        dark
        border="right"
        color="error"
      >
        No Hay Registros para Mostrar
      </v-alert>
      <v-card-text
        class="text-left text-body-2 font-weight-bold"
        v-if="step !== 1"
      >
        <v-icon large color="accent" @click="handleBack">
          mdi-chevron-left
        </v-icon>
        <span class="mx-2">
          {{ currentTitle }}
        </span>
      </v-card-text>
      <div
        class="d-flex justify-space-between"
        v-if="!peticionDocCliente"
      >
        <pdfCliente
          :page="`clientedoc.php`"
          :xdata="infoTt(`ttDetDocPed`)"
          :xclisaldo="infoTt(`ttSaldos`)"
          :xcli="infoTt(`ttCliente`)"
          :namefile="`EstadoCuentaPendiente`"
          :titulo="`DETALLE ESTADO DE CUENTA PENDIENTE`"
        />

        <v-switch
          v-if="step === 1"
          class="mt-1 mx-5"
          v-model="chkGrpClie_Rif"
          color="accent"
          inset
          flat
          dense
          :label="chkGrpClie_Rif ? `Empresa` : 'Rif'"                          
        ></v-switch>

        <span class="font-weight-bold mr-3"
          >{{ ` Saldo: ` }}
          <strong
            :class="{
              'font-weight-bold': true,
              'red--text': saldoCliente.Pendiente[tipoMoneda] < 0,
            }"
            >{{
              `${format(saldoCliente.Pendiente[tipoMoneda], 1)} ${
                simboloMoneda[tipoMoneda]
              } `
            }}</strong
          >
        </span>
      </div>

      <v-window v-model="step">
        <v-window-item :value="1">
          <v-virtual-scroll
            :bench="benched"
            :items="peticionDocCliente ? [] : itemsCliente"
            height="490"
            item-height="90"
          >
            <template v-slot:default="{ item }">
              <v-list-item
                three-line
                :key="item.NumeroDoc"
                dense
                @click="handleDoc(item)"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-start">
                    <v-badge
                      color="primary"
                      :content="numDoc(chkGrpClie_Rif ? item.Empresa : item.NombreRif)"
                      class="ml-1"
                    >
                    </v-badge>
                    <span class="mx-6 text-wrap">
                      {{ chkGrpClie_Rif ? item.NombreCli : item.NombreRif }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> Monto: </span>
                    <span
                      :class="{
                        'font-weight-bold': true,
                        'red--text': Saldo(chkGrpClie_Rif ? item.Empresa : item.NombreRif, 'MontoOriginal') < 0,
                      }"
                      >{{
                        `${format(Saldo(chkGrpClie_Rif ? item.Empresa : item.NombreRif, `MontoOriginal`), 1)} ${
                          simboloMoneda[tipoMoneda]
                        }`
                      }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> Saldo: </span>
                    <span
                      :class="{
                        'font-weight-bold': true,
                        'red--text': Saldo(chkGrpClie_Rif ? item.Empresa : item.NombreRif, 'SaldoPendiente') < 0,
                      }"
                    >
                      {{
                        `${format(Saldo(chkGrpClie_Rif ? item.Empresa : item.NombreRif, `SaldoPendiente`), 1)} ${
                          simboloMoneda[tipoMoneda]
                        }`
                      }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-window-item>
        <v-window-item :value="2">
          <v-virtual-scroll
            :bench="benched"
            :items="detalleItemCliente(idempresa)"
            height="490"
            item-height="140"
          >
            <template v-slot:default="{ item }">
              <v-list-item
                tree-line
                dense
                :key="item.NumeroDoc"
                @click="
                  detalleTrack(
                    item.NumeroDoc,
                    item.FechaEntregaCli,
                    item.IndFactura,
                    item.TD,
                    item.TipoDoc
                  )
                "
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>Doc:</span>
                    <span class="font-weight-bold">
                      {{ `${item.NumeroDoc} ${item.TipoDoc}` }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="d-flex justify-space-between"
                  >
                    <span>Rif:</span>
                    <span class="font-weight-bold">
                      {{ `${item.Rif}` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="d-flex justify-space-between"
                    v-if="item.DiasMora !== 0"
                  >
                    <span>Mora:</span>
                    <span class="font-weight-bold">
                      {{ `${item.DiasMora}` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Emi:</span>
                    <span class="font-weight-bold">
                      {{ `${formatFecha(item.FechaEmision, 1)}` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Venc:</span>
                    <span class="font-weight-bold">
                      {{ `${formatFecha(item.FechaVence, 1)}  ` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> Monto: </span>
                    <span
                      :class="{
                        'red--text': item.MontoOriginal[tipoMoneda] < 0,
                      }"
                    >
                      {{
                        `${format(item.MontoOriginal[tipoMoneda], 1)} ${
                          simboloMoneda[tipoMoneda]
                        }`
                      }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> Saldo: </span>
                    <span
                      :class="{
                        'red--text': item.SaldoPendiente[tipoMoneda] < 0,
                      }"
                    >
                      {{
                        `${format(item.SaldoPendiente[tipoMoneda], 1)} ${
                          simboloMoneda[tipoMoneda]
                        } `
                      }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </template>
          </v-virtual-scroll>
        </v-window-item>
        <v-window-item :value="3">
          <v-card class="mx-auto mb-3 mt-12" flat width="550" elevation="1">
            <v-row align="center" justify="space-around">
              <v-col cols="12" class="my-3">
                <v-btn @click="() => (step = 5)" color="primary">
                  <linkfact
                    :itemfac="itemfac"
                    :numerodoc="numeroDocumento"
                    :tipodoc="tipodoc"
                    :idtab="0"
                    :transi="false"
                    :titulo="`DOCUMENTO`"
                  />
                </v-btn>
              </v-col>
              <v-col cols="12" class="my-6">
                <v-btn
                  depressed
                  color="success"
                  :disabled="fechaEntregaCli === null"
                  @click="() => step++"
                >
                  Ver Detalle de Despacho
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-window-item>
        <v-window-item :value="4">
          <TrackCliente
            :detallecliente="DetalleCliente"
            :numdoc="numeroDocumento"
          />
        </v-window-item>
        <v-window-item :value="5">
          <detallefact :key="idFactura" />
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
import linkfact from "@/components/DatosFactura";
import detallefact from "./DetalleFactura";
import { format, formatFecha } from "@/static/funciones";
import pdfCliente from "@/components/PdfDocCliente";
import TrackCliente from "./TrackCliente";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    linkfact,
    detallefact,
    pdfCliente,
    TrackCliente,
  },
  methods: {
    ...mapActions(["get_DetalleCliente"]),
    ...mapMutations([
      "set_OpcCli",
      "CRL_DetalleCliente",
      "CLR_ITEMSFACTDOC_PENDIENTES",
      "CLR_FACTDOC_PENDIENTES",
    ]),
    async obtenerDatos() {
      //this.CRL_DetalleCliente();
      this.CLR_ITEMSFACTDOC_PENDIENTES();
      this.CLR_FACTDOC_PENDIENTES();
      this.set_OpcCli(2);
      await this.get_DetalleCliente();
    },
    format,
    formatFecha,
    detalleTrack(numDoc, fecha, numfact, tipodoc, nbtipo) {
      if (nbtipo === "ANT") return;
      else {
        this.numeroDocumento = numDoc;
        this.fechaEntregaCli = fecha;
        this.itemfac = numfact;
        this.tipodoc = tipodoc;
        this.nbtipo = nbtipo;
        this.step++;
        this.idFactura++;
      }
    },
    handleBack() {
      if (this.step === 5) this.step = 3;
      else this.step--;
    },
    handleDoc(item) {
      this.nbcli = this.chkGrpClie_Rif ? item.NombreCli : item.NombreRif;
      this.idempresa = this.chkGrpClie_Rif ? item.Empresa : item.NombreRif;
      this.step++;
    },
    Saldo(id, key) {
      let num = 0;
      if (
        this.DetalleCliente &&
        Object.entries(this.DetalleCliente).length !== 0
      ) {
        let { dsDocument: dsDocument } = this.DetalleCliente;
        if (dsDocument !== undefined) {
          num = dsDocument?.ttDetDocPed
            ?.filter((x) => 
              this.chkGrpClie_Rif ? x.Empresa === id : x.NombreRif === id)
            .map((x) => x[key][this.tipoMoneda])
            .reduce((a, b) => a + b, 0);
        }
      }
      return num;
    },
    numDoc(id) {
      let num = 0;
      if (
        this.DetalleCliente &&
        Object.entries(this.DetalleCliente).length !== 0
      ) {
        let { dsDocument: dsDocument } = this.DetalleCliente;
        if (dsDocument !== undefined) {
          num = dsDocument?.ttDetDocPed?.filter((x) => 
            this.chkGrpClie_Rif ? x.Empresa === id : x.NombreRif === id
          ).length;
        }
      }
      return num;
    },
  },
  created() {
    this.obtenerDatos();
  },
  computed: {
    ...mapState([
      "DetalleCliente",
      "peticionDocCliente",
      "simboloMoneda",
      "tipoMoneda",
    ]),
    infoTt: function () {
      return function (idKey) {
        let datos = [];
        if (
          this.DetalleCliente &&
          Object.entries(this.DetalleCliente).length !== 0
        ) {
          const { dsDocument } = this.DetalleCliente;
          if (dsDocument && dsDocument.hasOwnProperty(idKey)) {
            datos = dsDocument[idKey];
          }
        }
        return datos;
      };
    },
    currentTitle() {
      const titulo = {
        1: "",
        2: this.nbcli,
        3: "SELECCIONE SU OPCIÓN",
        4: `DESPACHO DOC N° ${this.numeroDocumento}`,
        5: `DETALLE ${this.nbtipo} N° ${this.numeroDocumento}`,
      };
      return titulo[this.step];
    },

    detalleItemCliente: function () {
      let datos = [];
      return function (id) {
        if (
          this.DetalleCliente &&
          Object.entries(this.DetalleCliente).length !== 0
        ) {
          let { dsDocument: dsDocument } = this.DetalleCliente;
          if (dsDocument !== undefined) {
            datos = this.chkGrpClie_Rif ? 
              dsDocument?.ttDetDocPed?.filter((x) => id === x["Empresa"]) :
              dsDocument?.ttDetDocPed?.filter((x) => id === x["NombreRif"]) ;
          }
          return datos;
        }
      };
    },
    itemsCliente() {
      let datos = [];
      if (
        this.DetalleCliente &&
        Object.entries(this.DetalleCliente).length !== 0
      ) {
        let { dsDocument: dsDocument } = this.DetalleCliente;

        if (dsDocument !== undefined) {
          datos = dsDocument?.ttDetDocPed;
        }
        if (this.chkGrpClie_Rif) {
          const arrayUniqueByKey = [
            ...new Map(datos.map((item) => [item["Empresa"], item])).values(),
          ];
          return arrayUniqueByKey.sort(function (a, b) {
            if (a.Empresa > b.Empresa) {
              return 1;
            }
            if (a.Empresa < b.Empresa) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
        } else {
          const arrayUniqueByKey = [
            ...new Map(datos.map((item) => [item["NombreRif"], item])).values(),
          ];
          return arrayUniqueByKey.sort(function (a, b) {
            if (a.NombreRif > b.NombreRif) {
              return 1;
            }
            if (a.NombreRif < b.NombreRif) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

        }
        
      }
    },
    saldoCliente() {
      let saldo = {};
      if (
        this.DetalleCliente &&
        Object.entries(this.DetalleCliente).length !== 0
      ) {
        let { dsDocument: dsDocument } = this.DetalleCliente;

        if (dsDocument !== undefined) {
          saldo = dsDocument?.ttTotalSaldos[0];
        }
      }
      return saldo;
    },
  },
  data() {
    return {
      benched: 0,
      step: 1,
      numeroDocumento: 0,
      nbtipo: "",
      fechaEntregaCli: false,
      itemfac: "",
      tipodoc: "",
      idFactura: 0,
      nbcli: "",
      idempresa: 0,
      headers: [
        {
          text: "Ver",
          align: "center",
          value: "NumeroDoc",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Rif",
          align: "center",
          value: "Rif",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Documento",
          align: "center",
          value: "NumeroDoc",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Tipo Doc",
          align: "center",
          value: "TipoDoc",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Fecha Emision",
          align: "center",
          value: "FechaEmision",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Entrega Cliente",
          align: "center",
          value: "FechaEntregaCli",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Fecha Vence",
          align: "center",
          value: "FechaVence",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },

        {
          text: "Monto Original",
          align: "right",
          value: `MontoOriginal`,
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Saldo",
          align: "right",
          value: "SaldoPendiente",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Mora",
          align: "center",
          value: "DiasMora",
          groupable: false,
          sortable: true,
          class: "subtitle-2 font-weight-bold",
        },
      ],
      chkGrpClie_Rif: true
    };
  },
};
</script>
